export const ADMIN_CONTENT_MAX_WIDTH = "max-w-5xl";
export const ADMIN_OBJECT_DETAIL_MAX_WIDTH = "max-w-3xl";
